import { ConfigService } from "@/api/config"
import type { WasteShippingConfig } from "@/models"
import { reactive } from "vue"

const rawConfig = await new ConfigService().getConfig()
document.title = `Guernsey ${rawConfig.appName}`

const config: WasteShippingConfig = reactive(rawConfig)
export function useAppConfig(): WasteShippingConfig {
	return config
}
